if (!customElements.get('cart-terms')) {
  class CartTerms extends HTMLElement {
    constructor() {
      super();
      this.cartTermsCheckbox = this.querySelector('.js-cart-terms-checkbox');
      if (!this.cartTermsCheckbox) {
        return;
      }

      var formId = this.cartTermsCheckbox.getAttribute('form');
      this.form = formId ? document.getElementById(formId) : this.closest('form');
      if (!this.form) {
        return;
      }
      this.formId = this.form.getAttribute('id');

      this.submitHandler = this.handleSubmit.bind(this);
      this.changeHandler = this.handleChange.bind(this);
      this.checkoutClickHandler = this.handleCheckoutClick.bind(this);

      this.checkoutButtons = this.getCheckoutButtons();

      this.form.addEventListener('submit', this.submitHandler);
      if (this.cartTermsCheckbox) {
        this.cartTermsCheckbox.addEventListener('change', this.changeHandler);
      }
      // Capture clicks on any checkout buttons related to this form, even if external scripts modify them.
      document.addEventListener('click', this.checkoutClickHandler, true);

      // Force initial state: terms unchecked and checkout disabled until accepted.
      this.cartTermsCheckbox.checked = false;
      this.toggleCheckoutButtons(false);
    }

    disconnectedCallback() {
      if (this.form && this.submitHandler) {
        this.form.removeEventListener('submit', this.submitHandler);
      }
      if (this.cartTermsCheckbox && this.changeHandler) {
        this.cartTermsCheckbox.removeEventListener('change', this.changeHandler);
      }
       if (this.checkoutClickHandler) {
         document.removeEventListener('click', this.checkoutClickHandler, true);
       }
    }

    /**
     * Returns all checkout buttons associated with this cart form.
     * Handles buttons inside the form and buttons referencing the form via the "form" attribute.
     * @returns {Array<Element>}
     */
    getCheckoutButtons() {
      var buttons = [];
      if (!this.form) return buttons;

      var formId = this.form.getAttribute('id');

      // Buttons outside the form using the form attribute.
      if (formId) {
        var externalButtons = document.querySelectorAll(
          'button[name="checkout"][form="' + formId + '"], ' +
          '[type="submit"][name="checkout"][form="' + formId + '"]'
        );
        buttons = buttons.concat(Array.prototype.slice.call(externalButtons));
      }

      // Buttons inside the form.
      var internalButtons = this.form.querySelectorAll(
        'button[name="checkout"], [type="submit"][name="checkout"]'
      );
      buttons = buttons.concat(Array.prototype.slice.call(internalButtons));

      return buttons;
    }

    /**
     * Enables/disables all checkout buttons.
     * @param {boolean} isEnabled
     */
    toggleCheckoutButtons(isEnabled) {
      // Refresh buttons in case external scripts have replaced them.
      this.checkoutButtons = this.getCheckoutButtons();
      if (!this.checkoutButtons || !this.checkoutButtons.length) return;

      this.checkoutButtons.forEach(function(button) {
        button.disabled = !isEnabled;
      });
    }

    /**
     * Handles checkbox change.
     */
    handleChange() {
      this.toggleCheckoutButtons(this.cartTermsCheckbox && this.cartTermsCheckbox.checked);
    }

    /**
     * Handles clicks on checkout buttons, guarding against external scripts re-enabling them.
     * @param {object} evt - Event object.
     */
    handleCheckoutClick(evt) {
      var target = evt.target;
      var button = null;

      // Walk up the DOM tree to find a related checkout button.
      while (target && target !== document) {
        if (target.tagName === 'BUTTON' || target.tagName === 'INPUT') {
          if (target.name === 'checkout') {
            button = target;
            break;
          }
        }
        target = target.parentElement;
      }

      if (!button) {
        return;
      }

      // Ensure this button belongs to our form (via form attribute or parent form).
      var belongsToForm = false;
      var buttonFormId = button.getAttribute('form');
      if (buttonFormId && this.formId && buttonFormId === this.formId) {
        belongsToForm = true;
      } else if (button.form && button.form === this.form) {
        belongsToForm = true;
      }

      if (!belongsToForm) {
        return;
      }

      if (!this.cartTermsCheckbox || !this.cartTermsCheckbox.checked) {
        // Block checkout if terms not accepted, even if button appears enabled.
        evt.preventDefault();
        evt.stopPropagation();
        this.toggleCheckoutButtons(false);
        alert(theme.strings.cartTermsConfirmation); // eslint-disable-line
      }
    }

    /**
     * Handles cart form submit
     * @param {object} evt - Event object.
     */
    handleSubmit(evt) {
      if (!this.cartTermsCheckbox.checked) {
        evt.preventDefault();
        alert(theme.strings.cartTermsConfirmation); // eslint-disable-line
      }
    }
  }
  customElements.define('cart-terms', CartTerms);
}
